import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VALUE, UNLIMITED, NO, YES } from "const"
import {
    StoreType,
    ChangePackageSettings,
    setPackageSettings,
} from "client/store"
import {
    Collapse,
    PageForm,
    FormGroup,
    Label,
    RadioButton,
    Input,
} from "client/components"

const Drive = () => {
    const settings = useSelector((state: StoreType) => state.package.packageSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (newSettings: ChangePackageSettings) => {
        dispatch(setPackageSettings(newSettings))
    }

    const {
        driveSpace,
        driveSpaceValue,
        cloudDrivesAllowed,
    } = settings

    return (
        <Collapse
            show={show}
            title={lang.drive}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>{lang.driveSpace}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={driveSpace === 0}
                            onChange={() => onChange({ driveSpace: 0 })}
                            title="0 GB"
                        />
                        <RadioButton
                            checked={driveSpace === VALUE}
                            onChange={() => onChange({ driveSpace: VALUE })}
                            title={(
                                <div>
                                    <Input
                                        type="text"
                                        value={driveSpaceValue}
                                        onChange={(e) => onChange({ driveSpaceValue: parseInt(e.target.value, 10) || 0 })}
                                    />
                                    GB
                                </div>
                            )}
                        />
                        <RadioButton
                            checked={driveSpace === UNLIMITED}
                            onChange={() => onChange({ driveSpace: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.cloudDrivesAllowed}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={cloudDrivesAllowed === NO}
                            onChange={() => onChange({ cloudDrivesAllowed: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={cloudDrivesAllowed === YES}
                            onChange={() => onChange({ cloudDrivesAllowed: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default Drive
